import {PriceContext, totalCharacterCount} from "../context/PriceContext";
import {ConfigContext} from "../context/ConfigContext";
import {TextSectionsListContext} from "../context/TextSectionsListContext";
import React, {useContext} from "react";
import {useLanguage} from "../context/LanguageContext";
import {mountingRequiresInquiry, resolveMounting} from "../services/erpMapping";

const Price = () => {
    const priceContext = useContext(PriceContext);
    const config = useContext(ConfigContext);
    const textSections = useContext(TextSectionsListContext);
    const {t} = useLanguage();

    if (priceContext.isPriceLoading) {
        return (
            <div>
                <div style={{height: '58px'}} className="h3">{t('price.calculating')}</div>
            </div>
        );
    }

    const currency = t('common.currency');
    const hasDiscount = Number(priceContext.discountPercent) > 0
        && priceContext.grossBeforeDiscount > priceContext.priceGross;
    const characters = totalCharacterCount(priceContext);
    // Mocowanie „na zapytanie" (reguły ACF mounting_type produktu) — cena orientacyjna, koszyk zablokowany.
    const inquiryRequired = mountingRequiresInquiry(config, resolveMounting(config, textSections).key);

    return (
        <div className="price-summary">
            {priceContext.unavailable && (
                <div className="price-summary__unavailable" role="alert">{t('price.unavailable')}</div>
            )}
            {inquiryRequired && (
                <div className="price-summary__unavailable" role="alert">{t('price.mountingInquiry')}</div>
            )}
            {hasDiscount && (
                <div className="price-summary__regular">
                    {t('price.beforeDiscount')} {priceContext.grossBeforeDiscount.toFixed(2)} {currency}
                    {' '}({t('price.discount')} {Math.round(priceContext.discountPercent)}%)
                </div>
            )}
            <div className="h3">{t('price.gross')} {priceContext.priceGross.toFixed(2)} {currency}</div>
            <div className="h3">{t('price.net')} {priceContext.priceNett.toFixed(2)} {currency}</div>
            {characters > 0 && (
                <div className="price-summary__characters">{t('price.characters')} {characters}</div>
            )}
        </div>
    );
};
export default Price;
